import React from 'react'
import renderHTML from 'react-render-html'

import accessibleIcon from '../../../../assets/icons/accessible-room.svg'

const BkFlowRoomCardAdaDescriptionAccordion = props => {
	const {
		adaDisclaimer,
		hotelLabels,
		toggledState,
		toggleEvent
	} = props

	return (
		<div className="bk-flow-room__card-ada-description accordion">
			<button
				className="u-txt-toggle-read-more u-font-small u-font-bold"
				onClick={ () => toggleEvent() }
			>
				<img
					src={accessibleIcon}
					alt="Toggle Accessible Room Details"
				/>

				{ toggledState ?
					hotelLabels.readMoreAccessibleRooms ? hotelLabels.readMoreAccessibleRooms : 'Read more about our Accessible Rooms'
				:
					hotelLabels.readMoreAccessibleRooms ? hotelLabels.readMoreAccessibleRooms : 'Read more about our Accessible Rooms'
				}

				<i className="material-icons">{ toggledState ? 'arrow_drop_up' : 'arrow_drop_down' }</i>
			</button>

			{ toggledState &&
				<div className="bk-flow-room__card-ada-description-content">
					{ renderHTML(adaDisclaimer) }
				</div>
			}
		</div>
	)
}

export default BkFlowRoomCardAdaDescriptionAccordion



// WEBPACK FOOTER //
// ./src/components/room/elements/accessiblity/BkFlowRoomCardAdaDescriptionAccordion.js